import { render, staticRenderFns } from "./FreelanceBoard.vue?vue&type=template&id=bf26b6a0&scoped=true&"
import script from "./FreelanceBoard.vue?vue&type=script&lang=js&"
export * from "./FreelanceBoard.vue?vue&type=script&lang=js&"
import style0 from "./FreelanceBoard.vue?vue&type=style&index=0&id=bf26b6a0&prod&lang=css&"
import style1 from "./FreelanceBoard.vue?vue&type=style&index=1&id=bf26b6a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf26b6a0",
  null
  
)

export default component.exports